import { useDocumentTitle as useBaseDocumentTitle } from '@uidotdev/usehooks';

export const useDocumentTitle = (title: string, suffix = ' - Arctic Wolf') =>
  useBaseDocumentTitle(`${title}${suffix}`);
